import { css } from "@emotion/core";

export const override = css`
  display: block;
  margin: 0 auto;
  position: absolute;
  margin-left: 50%;
  z-index: 1000;
  margin-right: 50%;
  top: 50%;
  width: 100vw;
  // background-color: black;
  // opacity: 0.75;
`;

export const overrideSidebar = css`
  display: block;
  margin: 0 auto;
  position: absolute;
  margin-left: 7%;
  z-index: 1000;
  top: 50%;
  width: 100vw;
`;

export const downloadBlock = css`
  display: block;
  margin: 58px 105px;
`;

export const overridedesigncriteria = css`
  display: block;
  margin: 0 auto;
`;

export const overridestampdocument = css`
  display: block;
  margin: auto;
`;

export const alignCenter = css`
  margin: 10% 48% 0;
`;

export const msToTime = (duration) => {
  if (duration > 0) {
    var minutes = Math.floor((duration / (1000 * 60)) % 60),
      hours = Math.floor((duration / (1000 * 60 * 60)) % 24);

    hours = hours < 10 ? "0" + hours : hours;
    minutes = minutes < 10 ? "0" + minutes : minutes;

    return hours + ":" + minutes;
  } else return "NA";
};
